import React from 'react';
import { FlatButton, Icon, Modal, Spacing, Text } from '@reservamos/elements';
import { Trans, useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { trackEvent } from 'user-analytics';
import { HOW_TO_EXCHANGE_MODAL_OPENED } from 'constants/TrackEvents';
import { getBrandHandler } from 'utils/Reserbus';
import InfoText from '../atoms/InfoText';
import './ExchangeInfoModal.scss';

/**
 * ExchangeInfoModal Functional Component
 *
 * A modal component that displays information related to the ticket exchange process.
 *
 * This component is typically used to show detailed information or instructions about exchanging tickets
 * in a modal window.
 *
 * @returns {JSX.Element} The rendered modal component displaying exchange information.
 */
const ExchangeInfoModal = () => {
  const { t } = useTranslation('exchange');
  const { env } = useSelector((state) => state.whitelabelConfig);
  const brandHandler = getBrandHandler(env.brand);

  const handleModalTriggerClick = () => {
    trackEvent(HOW_TO_EXCHANGE_MODAL_OPENED);
  };

  return (
    <Spacing size="XS" vertical>
      <Modal
        title={t(`modal_info.${brandHandler}.title`)}
        modalTrigger={
          <Spacing size="XS" alignItems="baseline">
            <div className="cursor-default" onClick={(e) => e.stopPropagation()}>
              <Icon type="CircleInfo" color="info" size="S" />
            </div>
            <FlatButton
              text={t(`modal_info.${brandHandler}.label_trigger`)}
              weight="semibold"
              size="S"
              onClick={handleModalTriggerClick}
            />
          </Spacing>
        }
      >
        <Spacing vertical size="L">
          <Text>{t('modal_info.find_the_data')}</Text>
          <Spacing vertical size="S">
            <InfoText icon="Amenity" textSize="M" alignment="baseline" iconColor="accent">
              {t(`modal_info.${brandHandler}.first`)}
            </InfoText>
            <InfoText icon="Amenity" textSize="M" alignment="baseline" iconColor="accent">
              <Trans t={t} i18nKey={`modal_info.${brandHandler}.second`}>
                <b />
              </Trans>
            </InfoText>
            <InfoText icon="Amenity" textSize="M" alignment="baseline" iconColor="accent">
              {t(`modal_info.${brandHandler}.third`)}
            </InfoText>
            <InfoText icon="Amenity" textSize="M" alignment="baseline" iconColor="accent">
              <Trans t={t} i18nKey={`modal_info.${brandHandler}.fourth`}>
                <b />
              </Trans>
            </InfoText>
          </Spacing>
          <i className={`operation-${brandHandler}`} />
        </Spacing>
      </Modal>
    </Spacing>
  );
};

export default ExchangeInfoModal;
